export const payload = {
  receiveMutation: 'RECEIVE_CHECKS',
  receivingMutation: 'RECEIVING_CHECKS',
  receiveMetadataMutation: 'RECEIVE_CHECK_METADATA',
  receiveFailureMutation: 'RECEIVE_CHECK_FAILURE',
  savingMutation: 'SAVING_CHECK',
  saveFailureMutation: 'SAVING_CHECK_FAILURE',
  incrementMutation: 'INCREMENT_CHECK_COUNT',
  updatingMutation: 'UPDATING_CHECK',
  updateFailureMutation: 'UPDATING_CHECK_FAILURE',
  deleteMutation: 'DELETE_CHECK',
  deletingMutation: 'DELETING_CHECK',
  deleteFailureMutation: 'DELETING_CHECK_FAILURE',
  resetMetaMutation: 'RESET_BUDGET_META',
  clearMutation: 'CLEAR_CHECK_STATE',
  moduleName: 'check',
  endpoint: 'checks'
}



// WEBPACK FOOTER //
// ./src/components/RouteComponents/Checks/actionPayload.js